import type { PropertyDetails } from "@/src/constants/propertyWizard";
import type { WizardPropertyPayload } from "@/src/types/propertyApi.types";
import { mapPropertyTypeToApi } from "@/src/utils/mapPropertyTypeToApi";
import { normalizeZipCodeForApi } from "@/src/utils/normalizeZipCodeForApi";

const parseYearBuilt = (value: string): number | undefined => {
  const parsed = Number.parseInt(value.trim(), 10);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return undefined;
  }
  return parsed;
};

export const buildWizardPropertyPayloadFromDetails = (
  details: PropertyDetails,
): WizardPropertyPayload => {
  const property: WizardPropertyPayload = {
    name: details.name.trim(),
    addressLine: details.addressLine.trim(),
    propertyType: mapPropertyTypeToApi(details.type),
  };

  const city = details.city.trim();
  const state = details.state.trim();
  const zipcode = normalizeZipCodeForApi(details.zipCode);
  const yearBuilt = parseYearBuilt(details.yearBuilt);
  const lotSize = details.lotSize.trim();

  if (city) property.city = city;
  if (state) property.state = state;
  if (zipcode) property.zipcode = zipcode;
  if (yearBuilt !== undefined) property.yearBuilt = yearBuilt;
  if (lotSize) property.lotSize = lotSize;
  if (typeof details.latitude === "number" && Number.isFinite(details.latitude)) {
    property.latitude = details.latitude;
  }
  if (typeof details.longitude === "number" && Number.isFinite(details.longitude)) {
    property.longitude = details.longitude;
  }
  if (details.relationship !== undefined) {
    property.relationship = details.relationship;
  }

  return property;
};
